import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from "@curves/ui-base";
import clsx from 'clsx';
import { SingleActionPrivacyDataToggle } from './overviewListActions';

const OverviewListSingleActions = ({ className, children, ...rest }) => {
    return (
        <Stack className={clsx('overview-list__action-group single-actions', className)} {...rest}>
            {children}
        </Stack>
    );
};

OverviewListSingleActions.PrivacyDataToggleAction = SingleActionPrivacyDataToggle;

OverviewListSingleActions.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
};

export default OverviewListSingleActions;
